import React, { Fragment, PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import classNames from 'classnames';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import TablePagination from '@material-ui/core/TablePagination';
import Tooltip from '@material-ui/core/Tooltip';
import { Input } from 'antd';

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing(),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
});


class EnhancedTableToolbar extends PureComponent {
    render() {
        const {
            classes,
            displayDataList,
            rowsPerPage,
            rowsPerPageOptions,
            page,
            TablePaginationActionsWrapped,
            onChangeRowsPerPage,
            onChangePage,
            withoutSearch,
            handleSearch,
            searchText,
            searchPlaceholder,
            updateData,
            disabled,
            labelDisplayedRows,
        } = this.props;

        return (
            <Toolbar
                className={classNames(classes.root)}
                style={{
                    backgroundColor: 'white',
                    width: '100%',
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    flexDirection: 'row-reverse',
                    justifyContent: 'space-between',
                }}
            >
                {(handleSearch && searchPlaceholder && !withoutSearch)
                    ? (
                        <Fragment>
                            <div style={{ order: 2 }} className="toolbar">
                                <Input
                                    placeholder={searchPlaceholder}
                                    onChange={handleSearch}
                                    defaultValue={searchText}
                                    disabled={disabled}
                                    style={{
                                        width: 350,
                                        padding: '5px 10px',
                                    }}
                                />
                            </div>
                            <div style={{
                                fontSize: 20,
                                position: 'absolute',
                                left: 390,
                                top: '50%',
                                transform: 'translateY(-50%)',
                            }}
                            >
                                <Tooltip title="refresh" placement="top">
                                    <span
                                        onClick={updateData}
                                        className="lnr lnr-sync"
                                        style={{ display: 'inline-block' }}
                                    />
                                </Tooltip>
                            </div>
                        </Fragment>
                    )

                    : (
                        <div style={{
                            fontSize: 20,
                            position: 'absolute',
                            left: 24,
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                        >
                            <Tooltip title="refresh" placement="top">
                                <span
                                    onClick={updateData}
                                    className="lnr lnr-sync"
                                    style={{ display: 'inline-block' }}
                                />
                            </Tooltip>
                        </div>
                    )

                }


                <TablePagination
                    count={(Array.isArray(displayDataList)) ? displayDataList.length : displayDataList}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={rowsPerPageOptions}
                    page={page}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    ActionsComponent={TablePaginationActionsWrapped}
                    style={{ borderBottom: 'none', cssFloat: 'right' }}
                    labelDisplayedRows={labelDisplayedRows}
                />

            </Toolbar>
        );
    }
}

export default EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);



// WEBPACK FOOTER //
// ./src/components/table_toolbar/table_toolbar.js